import React from "react";
import Title from "../../../components/Title/Title";

const OnlineSchedulepage = () => {
    return (
        <div>
            <Title>Online Schedule</Title>
            <p>[COMING SOON]</p>
        </div>
    )
}

export default OnlineSchedulepage
